import { render, staticRenderFns } from "./EventoManage.vue?vue&type=template&id=607ce957&scoped=true"
import script from "./EventoManage.vue?vue&type=script&lang=js"
export * from "./EventoManage.vue?vue&type=script&lang=js"
import style0 from "./EventoManage.vue?vue&type=style&index=0&id=607ce957&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607ce957",
  null
  
)

export default component.exports